module.exports = __webpack_public_path__ + "static/media/SM.4cfa019a.png";